
import React from "react";
import { Button } from "@/components/ui/button";
import { MessageCircle, HelpCircle, Loader2 } from "lucide-react";

interface HomeTabProps {
  navigateToTab: (tab: string) => void;
  changelogs: any[];
  isLoadingChangelogs: boolean;
  primaryColor?: string;
  textColor?: string;
}

const HomeTab = ({
  navigateToTab,
  changelogs,
  isLoadingChangelogs,
  primaryColor,
  textColor,
}: HomeTabProps) => {
  return (
    <div className="space-y-6 pb-4">
      <div className="space-y-3">
        <div className="grid grid-cols-1 gap-3">
          <Button
            onClick={() => navigateToTab('chat')}
            className="w-full justify-start h-14 text-base rounded-xl shadow-sm hover:shadow-md transition-all"
            style={primaryColor ? {
              backgroundColor: primaryColor,
              color: textColor
            } : {}}
          >
            <MessageCircle className="mr-3 h-5 w-5" /> Send us a message
          </Button>

          <Button
            variant="outline"
            onClick={() => navigateToTab('help')}
            className="w-full justify-start h-14 text-base rounded-xl custom-hover-button border-2 hover:border-primary transition-all"
          >
            <HelpCircle className="mr-3 h-5 w-5" /> Search for help
          </Button>
        </div>
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-foreground">Latest updates</h3>
          {changelogs.length > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigateToTab('changelog')}
              className="text-xs h-8 hover:bg-muted"
            >
              View all
            </Button>
          )}
        </div>
        <div className="space-y-3">
          {isLoadingChangelogs ? (
            <div className="flex justify-center py-8">
              <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
            </div>
          ) : changelogs.length === 0 ? (
            <div className="text-center text-muted-foreground py-8 text-sm bg-muted/20 rounded-xl">
              <p>No updates available</p>
            </div>
          ) : (
            changelogs.slice(0, 3).map(log => (
              <div key={log.id} className="p-4 border rounded-xl bg-gradient-to-br from-muted/30 to-muted/10 hover:from-muted/50 hover:to-muted/30 transition-all cursor-pointer" onClick={() => navigateToTab('changelog')}>
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h4 className="font-semibold text-sm line-clamp-1">{log.title}</h4>
                  <span className="text-xs text-muted-foreground whitespace-nowrap">{new Date(log.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span>
                </div>
                <p className="text-xs text-muted-foreground line-clamp-2">{log.description?.replace(/<[^>]*>/g, '')}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeTab;
